// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"2959":"5bad7586ebbcef59b374","6912":"98ccd0ef50a72f7ce413","7513":"e7bbee782e2a35847914"}[chunkId] + ".js";
};